import { Link } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { routes } from "@/router/all_routes";

export function AccessDeniedPage() {
  const { logout, user } = useAuth();

  return (
    <div className="suite-center-message">
      <div className="suite-login-card text-center">
        <h1 className="h5">Accès refusé</h1>
        <p className="text-muted">
          Le compte <strong>{user?.email}</strong> n&apos;a accès à aucun module
          licencié sur ce tenant, ou vos permissions sont insuffisantes.
        </p>
        <div className="d-flex gap-2 justify-content-center mt-3">
          <Link to={routes.login} className="btn btn-outline-primary btn-sm">
            Autre compte
          </Link>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => logout()}>
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
}
